<template>
    <svg aria-hidden="true" focusable="false" width="115" height="135" viewBox="0 0 115 135" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="115" height="135" fill="#36AAAB" />
        <path
            d="M76.6677 44.3456C76.6677 54.7537 68.2302 63.1911 57.8221 63.1911C47.414 63.1911 38.9766 54.7537 38.9766 44.3456C38.9766 33.9374 47.414 25.5 57.8221 25.5C68.2302 25.5 76.6677 33.9374 76.6677 44.3456Z"
            fill="white"
            stroke="white"
            stroke-miterlimit="10" />
        <path
            d="M89.7411 109.62H26.2832C24.762 109.62 23.5224 108.387 23.5 106.858V84.4383C23.5 77.3947 29.2097 71.7082 36.2302 71.7082H79.7698C86.8135 71.7082 92.5 77.4179 92.5 84.4383V106.862C92.5 108.385 91.2647 109.62 89.7411 109.62Z"
            fill="white"
            stroke="white"
            stroke-miterlimit="10" />
    </svg>
</template>
